// data lỗi Viettin bank
export const dataErrorVTB = {
    ["01"]: {text: "Sai thông tin Merchant_ID/ Provider_ID"},
    ["02"]: {text: "Thẻ ở trạng thái không hợp lệ"},
    ["03"]: {text: "Thẻ chưa được đăng ký dịch vụ Thanh toán Trực tuyến"},
    ["04"]: {text: "Không xác thực được thông tin chủ thẻ(sai thông tin ngày phát hành hoặc họ tên in trên thẻ)"},
    ["05"]: {text: "Tài khoản gắn với Thẻ không đủ số dư để thanh toán"},
    ["06"]: {text: "Tài khoản gắn với Thẻ ở trạng thái không thực hiện được giao dịch"},
    ["07"]: {text: "Giao dịch bị gửi trùng lặp"},
    ["08"]: {text: "Mã giao dịch bỏ trống hoặc sai quy định"},
    ["09"]: {text: "Giao dịch không thành công do lỗi hệ thống"},
    ["10"]: {text: "Lỗi xảy ra khi CẤP TOKEN thanh toán"},
    ["11"]: {text: "Lỗi xảy ra khi HỦY TOKEN thanh toán"},
    ["12"]: {text: "TOKEN chưa được Active"},
    ["13"]: {text: "TOKEN đã được cấp cho Thẻ của KH (PROVIDER_CU ST_ID)"},
    ["14"]: {text: "Không tìm thấy thông tin TOKEN"},
    ["15"]: {text: "TOKEN đã bị hết hạn sử dụng"},
    ["16"]: {text: "TOKEN bị hạn chế sử dụng tạm thời"},
    ["17"]: {text: "TOKEN đã bị hủy bỏ"},
    ["18"]: {text: "Khuôn mặt không trùng khớp"},
    ["20"]: {text: "Vượt hạn mức thanh toán cho phép cần xác thực OTP"},
    ["21"]: {text: "Số tiền vượt quá hạn mức tối thiểu /lần giao dịch"},
    ["22"]: {text: "Số tiền vượt quá hạn mức tối đa / lần giao dịch"},
    ["23"]: {text: "Số tiền vượt quá hạn mức tối đa / ngày giao dịch"},
    ["24"]: {text: "Tài khoản dịch vụ không tồn tại"},
    ["25"]: {text: "Tài khoản dịch vụ không ở trạng thái Active"},
    ["26"]: {text: "Số tiền thanh toán không hợp lệ, sai format"},
    ["27"]: {text: "Tài khoản dịch vụ không đủ số dư giao dịch"},
    ["31"]: {text: "OTP bị sai"},
    ["32"]: {text: "Quá số lần cho phép nhập sai OTP"},
    ["33"]: {text: "OTP quá hạn sử dụng"},
    ["34"]: {text: "Giao dịch đã thực hiện xác thực, không xác thực lại được"},
    ["35"]: {text: "Không tồn tại giao dịch cần xác thực"},
    ["36"]: {text: "Lỗi khi gửi OTP cho số điện thoại của khách hàng"},
    ["37"]: {text: "Không tạo được giao dịch thanh toán"},
    ["40"]: {text: "Giao dịch đã trừ tiền thành công phía VTB"},
    ["41"]: {text: "Giao dịch đã được trừ tiền nhưng chưa thành công"},
    ["42"]: {text: "Giao dịch tồn tại nhưng chưa thành công"},
    ["43"]: {text: "Giao dịch không tồn tại trên hệ thống VTB"},
    ["44"]: {text: "Sai tham số vấn tin dịch vụ"},
    ["50"]: {text: "Không tìm thấy giao dịch yêu cầu Hoàn tiền"},
    ["51"]: {text: "Số tiền yêu cầu Hoàn tiền không hợp lệ"},
    ["52"]: {text: "Giao dịch Hoàn tiền không thành công"},
    ["53"]: {text: "Ðã tồn tại giao dịch hoàn tiền (trùng số refund id)"},
    ["54"]: {text: "Không tạo được giao dịch hoàn tiền"},
    ["57"]: {text: "Không tìm thấy thông tin Khách hàng"},
    ["58"]: {text: "Khách hàng chưa đăng ký Sinh trắc học tại VietinBank."},
    ["59"]: {text: "Khuôn mặt không trùng khớp"},
    ["61"]: {text: "Thông tin người thụ hưởng sai"},
    ["62"]: {text: "Thông tin tài khoản thụ hưởng sai"},
    ["63"]: {text: "Không tồn tại thông tin HÐ"},
    ["64"]: {text: "Không tồn tại thông tin NCC"},
    ["70"]: {text: "Ðã đăng ký dịch vụ TTTT tại Bank"},
    ["71"]: {text: "Lỗi xảy ra trong quá trình đăng ký dịch vụ"},
    ["75"]: {text: "So GTTT(giấy tờ tùy thân: CMND, hộ chiếu,...) không trùng khớp"},
    ["76"]: {text: "Số điện thoại không trùng khớp với TT của KH"},
    ["89"]: {text: "Verify chữ ký đối tác bị lỗi"},
    ["90"]: {text: "Sai tham số API"},
    ["91"]: {text: "Sai checksum"},
    ["92"]: {text: "Không lấy được thông tin tham số dịch vụ"},
    ["93"]: {text: "Giao dịch bị lỗi(Timeout, lỗi hệ thống)"},
    ["94"]: {text: "Kênh bị hạn chế giao dịch"},
    ["95"]: {text: "IP bị hạn chế giao dịch"},
    ["96"]: {text: "Lỗi lưu dữ liệu vào DB"},
    ["99"]: {text: "Lỗi hệ thống"},
    ["FP00"]: {text: "Không tồn tại CIF"},
    ["FP02"]: {text: "Tồn tại CIF có STH không trùng khớp ảnh gửi vào"},
    ["FP03"]: {text: "Không có thông tin STH để đối sánh"},
    ["-99"]: {text: "Không nhận được lỗi từ ngân hàng"},
    ["-100"]: {text: "Giao dịch chưa hoàn tất"},
    ["-1"]: {text: "Không có tài khoản mặc định"},
    ["-2"]: {text: "Chưa đăng ký iPay"},
}